import React, { useState } from 'react'
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Button,
  FormControl,
  FormLabel,
  Input,
  Textarea,
  useToast,
} from '@chakra-ui/react'
import { whitelistService } from '../services/api'

interface AddWhitelistModalProps {
  isOpen: boolean
  onClose: () => void
  onSuccess: () => void
}

const AddWhitelistModal: React.FC<AddWhitelistModalProps> = ({
  isOpen,
  onClose,
  onSuccess,
}) => {
  const [walletAddress, setWalletAddress] = useState('')
  const [description, setDescription] = useState('')
  const [isSubmitting, setIsSubmitting] = useState(false)
  const toast = useToast()


  const resetForm = () => {
    setWalletAddress('')
    setDescription('')
  }

  const handleClose = () => {
    resetForm()
    onClose()
  }


  const handleSubmit = async () => {
    if (!walletAddress) {
      toast({
        title: 'Error',
        description: 'Wallet address is required',
        status: 'error',
        duration: 3000,
        isClosable: true,
      })
      return
    }

    try {
      setIsSubmitting(true)
      await whitelistService.addToWhitelist({
        wallet_address: walletAddress,
        description: description,
      })
      toast({
        title: 'Success',
        description: 'Address added to whitelist',
        status: 'success',
        duration: 3000,
        isClosable: true,
      })
      resetForm()
      onSuccess()
      onClose()
    } catch (error) {
      toast({
        title: 'Error',
        description: 'Failed to add address to whitelist',
        status: 'error',
        duration: 3000,
        isClosable: true,
      })
    } finally {
      setIsSubmitting(false)
    }
  }

  return (
    <Modal isOpen={isOpen} onClose={handleClose}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Add to Whitelist</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <FormControl isRequired>
            <FormLabel>Wallet Address</FormLabel>
            <Input
              placeholder="0x..."
              value={walletAddress}
              onChange={(e) => setWalletAddress(e.target.value)}
            />
          </FormControl>
          <FormControl mt={4}>
            <FormLabel>Description (Optional)</FormLabel>
            <Textarea
              placeholder="Add a description about this address"
              value={description}
              onChange={(e) => setDescription(e.target.value)}
            />
          </FormControl>
        </ModalBody>

        <ModalFooter>
          <Button variant="ghost" mr={3} onClick={handleClose}>
            Cancel
          </Button>
          <Button
            colorScheme="blue"
            onClick={handleSubmit}
            isLoading={isSubmitting}
          >
            Add
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  )
}

export default AddWhitelistModal 